import styles from './ReportCardNavigation.module.css';

export interface ReportCardNavigationProps {
  currentProgram: string; // BACI code
  onPrevious: () => void;
  onNext: () => void;
  hasPrevious: boolean;
  hasNext: boolean;
  currentIndex: number;
  totalPrograms: number;
}

/**
 * ReportCardNavigation - Alphabetical navigation through programs
 *
 * Features:
 * - Previous/Next buttons
 * - Current position indicator (e.g., "5 of 250")
 * - Disabled state when at first/last program
 */
export function ReportCardNavigation({
  currentProgram,
  onPrevious,
  onNext,
  hasPrevious,
  hasNext,
  currentIndex,
  totalPrograms
}: ReportCardNavigationProps) {
  return (
    <nav className={styles.navigation}>
      <button
        type="button"
        onClick={onPrevious}
        disabled={!hasPrevious}
        className={styles.navButton}
        aria-label="Previous program"
      >
        ← Previous
      </button>

      <div className={styles.position}>
        <span className={styles.currentProgram}>{currentProgram}</span>
        <span className={styles.counter}>
          {currentIndex + 1} of {totalPrograms}
        </span>
      </div>

      <button
        type="button"
        onClick={onNext}
        disabled={!hasNext}
        className={styles.navButton}
        aria-label="Next program"
      >
        Next →
      </button>
    </nav>
  );
}

export default ReportCardNavigation;
